import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { PWAInstallPrompt } from './PWAInstallPrompt';
import { Toaster } from '@/components/ui/sonner';
import { registerPushSubscription, requestNotificationPermission } from '@/utils/pushNotifications';

export const Layout = () => {
  useEffect(() => {
    // Register push notifications after login
    const setup = async () => {
      const perm = await requestNotificationPermission();
      if (perm === 'granted') {
        await registerPushSubscription();
      }
    };
    setup();
  }, []);

  return (
    <div className="flex min-h-[100dvh] bg-slate-100">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        <TopBar />
        <main className="flex-1 overflow-auto pb-safe">
          <Outlet />
        </main>
      </div>
      <PWAInstallPrompt />
      <Toaster position="top-right" />
    </div>
  );
};
